module.exports = __webpack_public_path__ + "static/josh_edited-2d7cc97fcc8ebf4089c511977ea0d7fa.jpg";